/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ActionContext, Module } from 'vuex';
import store from '@/store';

import type RootStateType from '@/store/types';
import generateMutations, { UPDATE_STATE_TYPE } from '@/store/generate-mutations';
import { getGalileoAb } from '@/shared/galileoAb';
import { ABResEnum } from '@/enums/abExperiment';
import { CouponTypeEnum } from '@/api/coupon/types';
import platform from '@/shared/utils/platform';
import type { CouponDiscountRateStateType } from './types';
import { supportCalcDiscountCouponTypes } from './product';

const moduleStore: Module<CouponDiscountRateStateType, RootStateType> = {
  state: {
    /** 优惠券折扣利率实验结果 */
    couponDiscountRateExperimentRes: null,
  },

  getters: {
    /** 展示优惠利率实验组，为实验组1或实验组3 */
    showCouponDiscountRateExperiment(state: CouponDiscountRateStateType): boolean {
      return state.couponDiscountRateExperimentRes !== null
      && (state.couponDiscountRateExperimentRes === ABResEnum.HINT
        || state.couponDiscountRateExperimentRes === ABResEnum.HINT3);
    },
    /** 展示优惠券挽留弹窗，为实验组2或实验组3 */
    showCouponRetainPopupExperiment(state: CouponDiscountRateStateType): boolean {
      return state.couponDiscountRateExperimentRes !== null
      && (state.couponDiscountRateExperimentRes === ABResEnum.HINT2
        || state.couponDiscountRateExperimentRes === ABResEnum.HINT3);
    },
    /** 展示优惠券限制，为实验组1、2、3 */
    isCouponLimitExperiment(state: CouponDiscountRateStateType): boolean {
      return state.couponDiscountRateExperimentRes !== null
      && (state.couponDiscountRateExperimentRes === ABResEnum.HINT
        || state.couponDiscountRateExperimentRes === ABResEnum.HINT2
        || state.couponDiscountRateExperimentRes === ABResEnum.HINT3);
    },
  },

  actions: {
    /**
     * 伽利略实验：
     * 实验名称：优惠券折扣率实验
     * 实验目的：测试优惠券折扣率实验分流结果
     */
    async getCouponDiscountRateExperimentRes(
      context: ActionContext<CouponDiscountRateStateType, RootStateType>,
    ) {
      const {
        couponList,
        coupon,
      } = store.state.applyProduct;

      const { showSpeed } = store.state.loanRight;

      // 自营有权益资方(24+、20+)单通道模式
      const isNeedRightCapitalSinglePassage = store.getters['loanRight/isNeedRightCapitalSinglePassage'] as unknown as boolean;
      // 24权益+纯24双承接模式
      const isDoublePassagewayPattern24RightsAndPure24 = store.getters['applyProduct/isDoublePassagewayPattern24RightsAndPure24'] as unknown as boolean;
      /**
       * 获取实验条件
       * 1. 未设置过实验结果
       * 2. 优惠券数量大于0
       * 3. 优惠券类型为支持计算优惠折扣的优惠券类型
       * 4. 24权益资方或24权益+纯24双承接模式
       * 5. 已选中优惠券
       * 6. 权益左侧通道
       */
      if (
        platform.isHelloApp
        && context.state.couponDiscountRateExperimentRes === null
        && couponList.length > 0
        && couponList.some(
          (item) => supportCalcDiscountCouponTypes.includes(item.freeCouponType as CouponTypeEnum),
        )
        && coupon
        && (isNeedRightCapitalSinglePassage || isDoublePassagewayPattern24RightsAndPure24)
        && showSpeed
      ) {
        const { result } = await getGalileoAb().getAbResCatchError('202510231711238844', '202510231711238965');
        if (result) {
          context.dispatch(UPDATE_STATE_TYPE, {
            couponDiscountRateExperimentRes: result,
          });
        }
      }
    },
  },
};

export default generateMutations(moduleStore);
